// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__ddIsb","large":"styles_large__3M-IK"};